export default class VanillaItemTags {
    public static readonly Arrow = 'minecraft:arrow';
    public static readonly Banner = 'minecraft:banner';
    public static readonly Boat = 'minecraft:boat';
    public static readonly Boats = 'minecraft:boats';
    public static readonly BookshelfBooks = 'minecraft:bookshelf_books';
    public static readonly ChainmailTier = 'minecraft:chainmail_tier';
    public static readonly Coals = 'minecraft:coals';
    public static readonly CrimsonStems = 'minecraft:crimson_stems';
    public static readonly DecoratedPotSherds = 'minecraft:decorated_pot_sherds';
    public static readonly DiamondTier = 'minecraft:diamond_tier';
    public static readonly Digger = 'minecraft:digger';
    public static readonly Door = 'minecraft:door';
    public static readonly GoldenTier = 'minecraft:golden_tier';
    public static readonly HangingActor = 'minecraft:hanging_actor';
    public static readonly HangingSign = 'minecraft:hanging_sign';
    public static readonly HorseArmor = 'minecraft:horse_armor';
    public static readonly IronTier = 'minecraft:iron_tier';
    public static readonly IsArmor = 'minecraft:is_armor';
    public static readonly IsAxe = 'minecraft:is_axe';
    public static readonly IsCooked = 'minecraft:is_cooked';
    public static readonly IsFish = 'minecraft:is_fish';
    public static readonly IsFood = 'minecraft:is_food';
    public static readonly IsHoe = 'minecraft:is_hoe';
    public static readonly IsMeat = 'minecraft:is_meat';
    public static readonly IsMinecart = 'minecraft:is_minecart';
    public static readonly IsPickaxe = 'minecraft:is_pickaxe';
    public static readonly IsShears = 'minecraft:is_shears';
    public static readonly IsShovel = 'minecraft:is_shovel';
    public static readonly IsSword = 'minecraft:is_sword';
    public static readonly IsTool = 'minecraft:is_tool';
    public static readonly IsTrident = 'minecraft:is_trident';
    public static readonly LeatherTier = 'minecraft:leather_tier';
    public static readonly LecternBooks = 'minecraft:lectern_books';
    public static readonly Logs = 'minecraft:logs';
    public static readonly LogsThatBurn = 'minecraft:logs_that_burn';
    public static readonly MangroveLogs = 'minecraft:mangrove_logs';
    public static readonly MusicDisc = 'minecraft:music_disc';
    public static readonly NetheriteTier = 'minecraft:netherite_tier';
    public static readonly Planks = 'minecraft:planks';
    public static readonly Sand = 'minecraft:sand';
    public static readonly Sign = 'minecraft:sign';
    public static readonly SoulFireBaseBlocks = 'minecraft:soul_fire_base_blocks';
    public static readonly SpawnEgg = 'minecraft:spawn_egg';
    public static readonly StoneBricks = 'minecraft:stone_bricks';
    public static readonly StoneCraftingMaterials = 'minecraft:stone_crafting_materials';
    public static readonly StoneTier = 'minecraft:stone_tier';
    public static readonly StoneToolMaterials = 'minecraft:stone_tool_materials';
    public static readonly TransformMaterials = 'minecraft:transform_materials';
    public static readonly TransformTemplates = 'minecraft:transform_templates';
    public static readonly TransformableItems = 'minecraft:transformable_items';
    public static readonly TrimMaterials = 'minecraft:trim_materials';
    public static readonly TrimTemplates = 'minecraft:trim_templates';
    public static readonly TrimmableArmors = 'minecraft:trimmable_armors';
    public static readonly VibrationDamper = 'minecraft:vibration_damper';
    public static readonly WarpedStems = 'minecraft:warped_stems';
    public static readonly WoodenSlabs = 'minecraft:wooden_slabs';
    public static readonly WoodenTier = 'minecraft:wooden_tier';
    public static readonly Wool = 'minecraft:wool';
}